import { useMemo } from "react";
import { useDebouncedValue, SEARCH_DEBOUNCE_MS } from "./useDebouncedValue";

/**
 * Menggabungkan filter instan (dropdown/checkbox) dengan field teks yang di-debounce.
 * Request API hanya berubah setelah user berhenti mengetik pada field teks.
 */
export function useDebouncedTextFilters(filters, textKeys, delay = SEARCH_DEBOUNCE_MS) {
  const textValues = textKeys.map((key) => filters[key] ?? "");
  const textPayload = useMemo(
    () => JSON.stringify(textValues),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    textValues
  );

  const debouncedTextPayload = useDebouncedValue(textPayload, delay);

  const nonTextKeys = Object.keys(filters).filter((key) => !textKeys.includes(key));
  const nonTextValues = nonTextKeys.map((key) => filters[key]);

  return useMemo(() => {
    const result = { ...filters };
    const debouncedValues = JSON.parse(debouncedTextPayload);
    textKeys.forEach((key, index) => {
      result[key] = debouncedValues[index] ?? "";
    });
    return result;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedTextPayload, ...nonTextValues, textKeys.join(",")]);
}
